import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PrimaryButton from '~/components/buttons/PrimaryButton';
import SecondaryButton from '~/components/buttons/SecondaryButton';
import PromptModal from '~/components/modals/PromptModal';
const MarkPaperlessModal = ({ handleOnClose }) => {
    return (_jsx(PromptModal, { onClose: handleOnClose, subtitle: "Mark this case as paperless?", children: _jsxs("div", { className: "mt-8 flex justify-center gap-6", children: [_jsx(SecondaryButton, { text: "No" }), _jsx(PrimaryButton, { text: "Yes" })] }) }));
};
export default MarkPaperlessModal;
